<script lang="ts">
	import translations from "./RecaptchaDisclaimer.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";

	const translate = getTranslate(translations);

	let disclaimerClass = "";
	export { disclaimerClass as class };
</script>

<div class="text-2xs/none text-center tracking-[0.02em] {disclaimerClass}">
	{translate("text")}
	<a
		class="decoration-ltprimary-400 underline hover:decoration-transparent"
		href="https://policies.google.com/privacy"
		target="_blank"
		rel="noopener noreferrer">{translate("privacyPolicy")}</a
	>
	{translate("and")}
	<a
		class="decoration-ltprimary-400 underline hover:decoration-transparent"
		href="https://policies.google.com/terms"
		target="_blank"
		rel="noopener noreferrer">{translate("terms")}</a
	>
	{translate("company")}
</div>
